import BaseServiceTaal from "../../Service/BaseServiceTaal";
import TipologiaArea from "./TipologiaArea.repo";

export default class TipologiaAreaService extends BaseServiceTaal {
  getRepo = () => TipologiaArea.getInstanceTaal();
}
